var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUsdt = function SvgUsdt(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10Zm1.201-11.38V7.143h3.384V4.887H5.372v2.255h3.384V8.62c-2.75.126-4.819.671-4.819 1.324 0 .652 2.069 1.197 4.819 1.323v4.74H11.2v-4.74c2.746-.127 4.809-.671 4.809-1.323 0-.652-2.063-1.197-4.809-1.323Zm0 2.244c-.069.004-.423.025-1.213.025-.632 0-1.076-.018-1.232-.026v.002c-2.43-.107-4.244-.53-4.244-1.036S6.326 8.9 8.756 8.79v1.653c.158.011.613.038 1.242.038.755 0 1.133-.031 1.203-.038V8.792c2.425.109 4.235.532 4.235 1.037 0 .506-1.81.928-4.235 1.035Z",
    fill: "#26A17B"
  })));
};
export default SvgUsdt;